<template lang="pug" src="./sqlReports.pug"></template>
<style lang="scss" src="./sqlReports.scss" scoped></style>

<script>
import { mapState, mapGetters } from 'vuex'
import request from '@/utils/request'
import { downloadBlob } from '@/utils/helpers'
import uuid from 'uniq-id'

export default {
    data: () => ({
        chosenCategoryId: null,
        chosenReport: null,
        filters: {
            startDate: new Date().addDays(-1).format('{yyyy}-{MM}-{dd}'),
            endDate: new Date().addDays(1).format('{yyyy}-{MM}-{dd}'),
            startTime: '00:00',
            endTime: '23:59',
            query: null,
            groupId: null
        },
        reportData: {
            header: null,
            data: null,
            total: null
        },
        pagination: {
            page: 1,
            totalPages: 1
        },
        loading: false
    }),
    computed: {
        ...mapGetters(['permissions', 'type']),
        ...mapState({
            reports: state => state.sqlReports.reportsList,
            categories: function(state) {
                const categories = state.sqlReports.roleCategories.map(it => ({
                    id: it.id,
                    name: it.name
                }))

                if (this.reports.some(report => !report.categoryId)) {
                    categories.push({
                        id: null,
                        name: this.$vuetify.t('$vuetify.pages.ExtendedReports.Reports.another')
                    })
                }

                return categories
            }
        }),
        reportsByCategories() {
            return this.reports.filter(report => this.chosenCategoryId === report.categoryId)
        },
        showFilters() {
            return this.chosenReport && (
                this.chosenReport.useDates ||
                this.chosenReport.useQuery ||
                this.chosenReport.useTimes ||
                this.chosenReport.useGroups
            )
        },
        canShowTable() {
            return this.reportData && this.reportData.header && this.reportData.data
        },
        headers() {
            if (!this.reportData.header) return []

            return this.reportData.header.map(header => ({
                text: header,
                sortable: false,
                align: 'center'
            }))
        },
        canEditExtendedReports() {
            return this.type == 'admin' && this.permissions && this.permissions.includes('edit-extended-reports')
        },
        canGenerateToExcel() {
            return this.type == 'admin'
        }
    },
    created() {
        this.$store.dispatch('sqlReports/getReportsCategories', false)
            .then(() => {
                if (this.categories.length) {
                    const [{ id: firstCategoryId }] = this.categories
                    this.chosenCategoryId = firstCategoryId
                }
            })

        this.$store.dispatch('sqlReports/getReportsList')
            .then(() => {
                const [firstReport] = this.reportsByCategories
                this.chosenReport = firstReport
            })

        this.getGroups()
    },
    methods: {
        async getGroups() {
            await request({
                method: 'get',
                url: '/bonus-systems/groups'
            }).then(res => {
                if (res.data) {
                    this.groups = res.data.groups
                }
            })
        },
        changeReportCategory(categoryId) {
            this.chosenCategoryId = categoryId
            this.chosenReport = null
        },
        changeReport(report) {
            this.chosenReport = { ...report }
        },
        changeStartDate(date) {
            this.filters.startDate = date
        },
        changeEndDate(date) {
            this.filters.endDate = date
        },
        changeStartTime(time) {
            this.filters.startTime = time
        },
        changeEndTime(time) {
            this.filters.endTime = time
        },
        async generateReport(page = 1, excel = false) {
            if (this.loading) return

            this.loading = true
            this.resetReportData()

            await request({
                method: 'get',
                responseType: excel ? 'blob' : 'json',
                url: `/sql-reports/${this.chosenReport.id}/data`,
                params: {
                    q: this.filters.query,
                    ...Object.reject(this.filters, ['query']),
                    page,
                    excel
                }
            }).then(res => {
                if (res.data) {
                    if (excel) {
                        downloadBlob(res.data, `Report_${uuid()}.xlsx`); return
                    }

                    this.reportData = Object.assign({}, res.data)
                    this.pagination = {
                        page: res.data.page || 1,
                        totalPages: res.data.totalPages || 1
                    }
                }
            }).catch(error => {
                if (error.response && error.response.data.message) {
                    this.$store.dispatch('addMessage', {
                        type: 'error',
                        message: error.response && error.response.data && error.response.data.message,
                        locale: true
                    }, { root: true })
                }
            }).finally(() => {
                this.loading = false
            })
        },
        exportToExcel() {
            this.generateReport(1, true)
        },
        resetReportData() {
            this.reportData = {
                header: null,
                data: null,
                total: null
            }

            this.pagination = {
                page: 1,
                totalPages: 1
            }
        }
    }
}
</script>
